import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { AuthLink, AuthShell } from "@/components/account/AuthShell";
import { useAccount } from "@/context/AccountContext";
import { accountApi } from "@/lib/api";

const COPY = {
  checking: { icon: Loader2, title: "Verifico il link…", text: "Un attimo." },
  ok: { icon: CheckCircle2, title: "Email confermata.", text: "Perfetto! Ora nel tuo profilo trovi tutti gli ordini fatti con questa email e puoi seguire le spedizioni." },
  error: { icon: XCircle, title: "Link non valido.", text: "Il link è scaduto o è già stato usato. Accedi al tuo profilo e chiedine uno nuovo." },
};

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { setCustomer } = useAccount();
  const [state, setState] = useState("checking");
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    accountApi
      .post("/account/verify-email", { token: params.get("token") || "" })
      .then(() => {
        setState("ok");
        setCustomer((c) => (c ? { ...c, email_verified: true } : c));
      })
      .catch(() => setState("error"));
  }, [params, setCustomer]);

  const { icon: Icon, title, text } = COPY[state];
  return (
    <AuthShell testid="account-verify-page" lines={["Conferma", "email."]} kicker="sfushop · il tuo account">
      <div className="space-y-6" data-testid="account-verify-result" data-state={state}>
        <Icon className={`h-10 w-10 ${state === "ok" ? "text-acid" : state === "error" ? "text-red-400" : "animate-spin text-smoke"}`} />
        <p className="font-display text-2xl font-black uppercase leading-tight" data-testid="account-verify-title">{title}</p>
        <p className="text-bone/70">{text}</p>
        {state !== "checking" && <AuthLink to="/account" testid="account-verify-profile-link">Vai al tuo profilo</AuthLink>}
      </div>
    </AuthShell>
  );
}
